import React, { PropsWithChildren } from "react";

import css from "./ExtendedPanel.module.scss";

interface BaseProps {}

const ExtendedPanel = (props: PropsWithChildren<BaseProps>) => {
	return <div className={css.extendedPanel}>{props.children}</div>;
};

export default ExtendedPanel;
